import { useState, useEffect } from 'react';
import { createPersonContact, updatePersonContact } from '../../../service/api/personContactService';
import { toast } from 'sonner';

const ContactForm = ({ account = {}, accountId, onClose, onSuccess, editingContact }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  // Pré-remplissage pour édition
  useEffect(() => {
    if (editingContact) {
      setFirstName(editingContact.firstName || '');
      setLastName(editingContact.lastName || '');
      setPhoneNumber(editingContact.telephone || '');
      setEmail(editingContact.email || '');
      setIsEditing(true);
    } else {
      setFirstName('');
      setLastName('');
      setPhoneNumber('');
      setEmail('');
      setIsEditing(false);
    }
  }, [editingContact]);

  // Validation en temps réel
  const validateField = (name, value) => {
    let error = '';
    if (!value.trim()) {
      error = `${name} est requis.`;
    }
    setFormErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const errors = {
      firstName: firstName.trim() ? '' : 'Le prénom est requis.',
      lastName: lastName.trim() ? '' : 'Le nom est requis.',
      phoneNumber: phoneNumber.trim() ? '' : 'Le numéro de téléphone est requis.',
      email: email.trim() ? '' : 'L’email est requis.'
    };

    if (Object.values(errors).some(err => err)) {
      setFormErrors(errors);
      return;
    }

    const contactData = { accountId, firstName, lastName, telephone: phoneNumber, email };

    try {
      if (isEditing) {

        await updatePersonContact(editingContact.id, contactData);
        toast.success('Personne contact mise à jour avec succès');
      } else {
        await createPersonContact(contactData);
        toast.success('Personne contact créée avec succès');

      }
      onSuccess();
      onClose();
    } catch (err) {
      // console.error('Erreur lors de la soumission :', err);
      toast.error('Une erreur est survenue, veuillez réessayer.');
    }
  };

  return (
    <div className="modal fade show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between mt-3">
            <h5 className="modal-title">
              {isEditing ? 'Modifier' : 'Créer'} une personne a conctater en cas de soucis  pour <strong className='text-primary text-muted'>
              {account?.accountTypeName || "cette entreprise"}</strong> <strong className='text-primary'>
              {account?.companyName || "this company"}</strong>
            </h5>
            <button type="button" className="btn-close"  onClick={onClose}> </button>
          </div>

          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">Prénom</label>
                <input
                  type="text"
                  id="firstName"
                  className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`}
                  value={firstName}
                  onChange={e => { setFirstName(e.target.value); validateField('firstName', e.target.value); }}
                />
                {formErrors.firstName && <div className="invalid-feedback">{formErrors.firstName}</div>}
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Nom </label>
                <input
                  type="text"
                  id="lastName"
                  className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`}
                  value={lastName}
                  onChange={e => { setLastName(e.target.value); validateField('lastName', e.target.value); }}
                />
                {formErrors.lastName && <div className="invalid-feedback">{formErrors.lastName}</div>}
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  className={`form-control ${formErrors.email ? 'is-invalid' : ''}`}
                  value={email}
                  onChange={e => { setEmail(e.target.value); validateField('email', e.target.value); }}
                />
                {formErrors.email && <div className="invalid-feedback">{formErrors.email}</div>}
              </div>

              <div className="form-group">
                <label htmlFor="phoneNumber">Téléphone</label>
                <input
                  type="text"
                  id="phoneNumber"
                  className={`form-control ${formErrors.phoneNumber ? 'is-invalid' : ''}`}
                  value={phoneNumber}
                  onChange={e => { setPhoneNumber(e.target.value); validateField('phoneNumber', e.target.value); }}
                />
                {formErrors.phoneNumber && <div className="invalid-feedback">{formErrors.phoneNumber}</div>}
              </div>

              <div className="d-flex justify-content-between mt-3 ">
                <button type="submit" className="btn btn-primary me-2">
                  {isEditing ? 'Modifier' : 'Créer'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  Fermer
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
